// Disable 'ctrl a' shortcut which allows select all
$(function () {
    $(document).on('keydown', function (e) {
        if ((e.ctrlKey || e.metaKey) && e.which === 65) {
            e.preventDefault();
        }
    });
});

const availableYears = ['1', '2', '3', '4', '5'];

// Initial check for selected years
let selectedYears = $('input[name=\'years[]\']:checked').map(function () {
    return this.value;
}).get();

// Get value of hidden default programme year
const parsedValue = parseInt($('input[name="defaultprogrammeyear"]').val());
const defaultProgrammeYear = isNaN(parsedValue) ? null : parsedValue;

// Add the default programme year to the 'selectedYears' if it exists in the array 'availableYears'
if (defaultProgrammeYear !== null && availableYears.includes(defaultProgrammeYear.toString())) {
    selectedYears.push(defaultProgrammeYear.toString());
}

yearSelectCheck(selectedYears);

// Handle click on year checkboxes
$('[id^=years]').on('click', function () {
    let selectedYear = $(this).val();
    if ($(this).prop('checked')) {
        yearSections(selectedYear);
    } else {
        $('#results' + selectedYear).hide();
    }

    $('[data-year="' + selectedYear + '"]').toggle();
    updateSelectedYears();
});

// Handle change event on any year checkbox
$('[id^=years]').on('change', updateSelectedYears);

function updateSelectedYears() {
    selectedYears = $(':checkbox[name=\'years[]\']:checked').map(function () {
        return this.value;
    }).get();
    yearSelectCheck(selectedYears);
}

function yearSelectCheck(selectedYears) {
    for (const value of availableYears) {
        $('[data-year="' + value + '"]').toggle(selectedYears.includes(value));
    }
}

function canEdit(section) {
    var permittedSections = Object.values(allUserPermissions.sections);

    return section.subSectionList.some(function (subsection) {
        return subsection.id && permittedSections.includes(subsection.id);
    });
}

window.yearSections = function (selectedYear, selectedSectionsArray) {
    let data = {
        years: selectedYear,
    };
    $.ajax({
        type: 'GET',
        url: base_url + 'pages/ajax_getYearSections',
        data: data,
        dataType: 'json',
        beforeSend: function () {
            $('#loader').show().html('<i class="' + FontAwesome.prefix('solid', 'spinner', true) + '"></i> Loading Year ' + selectedYear + ' Sections...');
        },
        success: function (data) {
            let buildSelect = '';
            if (data.length > 0) {
                const label = '<label for="year' + selectedYear + '" class="control-label">Year ' + selectedYear + ' Sections</label>';
                buildSelect += label;
                buildSelect += '<select class="select2 form-control" size="10" multiple id="year' + selectedYear + '" name="year' + selectedYear + '[]">';

                let hasPermissions = false;

                $.each(data, function (_, page) {
                    if (isAdministrator || typeof allUserPermissions !== 'undefined' && Object.values(allUserPermissions.pages).includes(page.subpage_id)) {
                        hasPermissions = true;
                        buildSelect += '<optgroup label="' + page.subpage_name + '">';
                        $.each(page.sections, function (_, section) {
                            let selected = $.inArray(parseInt(section.id), selectedSectionsArray) === -1 ? '' : ' selected';
                            buildSelect += '<option ' + 'value="' + section.id + '"' + selected + '>' + section.name + '</option>';

                            $.each(section.subSectionList, function (_, subSection) {
                                let selectedSub = $.inArray(parseInt(subSection.id), selectedSectionsArray) === -1 ? '' : ' selected';
                                buildSelect += '<option value="' + subSection.id + '"' + selectedSub + '> -- ' + subSection.name + '</option>';
                            });
                        });

                        buildSelect += '</optgroup>';
                    } else  {
                        const canEditSectionInPage = page.sections.some(section =>
                            allUserPermissions.sections && Object.values(allUserPermissions.sections).includes(section.id));

                        const canEditSubsectionInPage = page.sections.some(section =>
                            section.subSectionList.some(subsection =>
                                allUserPermissions.sections &&
                                Object.values(allUserPermissions.sections).includes(subsection.id)));

                        if (canEditSectionInPage || canEditSubsectionInPage) {
                            hasPermissions = true;
                            buildSelect += '<optgroup label="' + page.subpage_name + '">';

                            $.each(page.sections, function (_, section) {
                                let canEditThisSection = Object.values(allUserPermissions.sections).includes(section.id);
                                let canEditSubsectionInSection = canEdit(section);
                                let isDisabledSection = canEditThisSection === false && canEditSubsectionInSection === true;

                                if (canEditThisSection || canEditSubsectionInSection) {
                                    let selected = $.inArray(parseInt(section.id), selectedSectionsArray) === -1 ? '' : ' selected';
                                    buildSelect += '<option ' + (isDisabledSection ? 'disabled ' : '') + 'value="' + section.id + '"' + selected + '>' + section.name + '</option>';

                                    $.each(section.subSectionList, function (_, subSection) {
                                        let canEditThisSubsection = Object.values(allUserPermissions.sections).includes(subSection.id);
                                        if (canEditThisSection || canEditThisSubsection) {
                                            let selectedSub = $.inArray(parseInt(subSection.id), selectedSectionsArray) === -1 ? '' : ' selected';
                                            buildSelect += '<option value="' + subSection.id + '"' + selectedSub + '> -- ' + subSection.name + '</option>';
                                        }
                                    });
                                }
                            });
                            buildSelect += '</optgroup>';
                        }
                    }
                });

                buildSelect += '</select>';
                buildSelect += ' <small class="text-muted">Hold down the Ctrl (windows)/Command (Mac) button to select multiple sections.</small>';

                if (hasPermissions === true) {
                    $('#results' + selectedYear).show().empty().append(buildSelect);
                } else {
                    $('#results' + selectedYear).show().empty().html($('<div>', {
                        html: label + '<br><i class="' + FontAwesome.prefix('solid', 'exclamation-triangle') + '"></i> No permissions for year ' + selectedYear + '.',
                    }));
                }
            } else {
                $('#results' + selectedYear).html($('<div>', {
                    text: 'No sections for the year selected.',
                }));
            }
        },
        complete: function () {
            $('#loader').hide();
        },
    });
};

// Function to update internal link radio buttons based on the selected years
function updateInternalLinkRadioButtons(existingYearSelection = null) {
    const lowestSelectedYear = getLowestSelectedYear();

    $('[name="internal-link-year"]').parent().hide();

    if ($('input[name="years[]"]:checked').length > 0 || defaultProgrammeYear !== null && defaultProgrammeYear > 0) {
        showRadioButtons(lowestSelectedYear, existingYearSelection);
        toggleHelpMessages();
    } else if (defaultProgrammeYear === 0) {
        handleAllYearsPage();
    } else {
        hideAllExceptErrorMessage();
    }
}

function showRadioButtons(lowestSelectedYear, existingYearSelection) {
    let yearSelected = false;
    for (let year = 0; year <= lowestSelectedYear; year++) {
        const radioButton = $(`#internal-link${year}`).parent();
        radioButton.show();
        if ((existingYearSelection !== null || year === lowestSelectedYear) && !yearSelected) {
            const checkedRadio = radioButton.find('[name="internal-link-year"]');
            checkedRadio.prop('checked', true);
            internalLinkYearSections(checkedRadio.val());
            yearSelected = true;
        }
    }
}

function toggleHelpMessages() {
    if (defaultProgrammeYear === null) {
        $('#internal-link-default-year-help').hide();
        $('#internal-link-help').show();
    } else {
        $('#internal-link-help').hide();
        $('#internal-link-default-year-help').show();
    }
}

function handleAllYearsPage() {
    $('[name="internal-link-year"]').prop('checked', false);
    $('#internal-link0').parent().show();
    $('#internal-link0').prop('checked', true).show();
    internalLinkYearSections('0');
    toggleHelpMessages();
}

function hideAllExceptErrorMessage() {
    $('#internal-link-help, #internal-link-all-years-help').hide();
    $('[name="internal-link-year"]').prop('checked', false);
    $('#internal-link-results').empty().html('Please select a Programme Year above').show();
}

function getLowestSelectedYear() {
    var selectedYears;
    if (defaultProgrammeYear === null) {
        selectedYears = $('input[name="years[]"]:checked').map(function () {
            return parseInt(this.value) || 1;
        }).get();

        selectedYears = selectedYears.length > 0 ? Math.min(...selectedYears) : 1;
    } else {
        selectedYears = defaultProgrammeYear;
    }

    return selectedYears;
}

if (typeof internalLinkUrl === 'undefined') {
    updateInternalLinkRadioButtons();
} else {
    // Regular expression to match year, page, and section numbers
    const match = internalLinkUrl.match(/year:(\d+)page:(\d+)(?:section:(\d+))?/);
    if (match) {
        var [, yearNumber, pageNumber, sectionNumber] = match.map(String);
        updateInternalLinkRadioButtons(parseInt(yearNumber));
        pageNumber = sectionNumber === undefined ? pageNumber : null;
        internalLinkYearSections(yearNumber, pageNumber, sectionNumber);
    } else {
        updateInternalLinkRadioButtons();
    }
}

$('[name="years[]"]').on('input', updateInternalLinkRadioButtons);

$('[name="internal-link-year"]').on('input', function () {
    internalLinkYearSections($(this).val());
});

function internalLinkYearSections(selectedYear, pageNumber = null, sectionNumber = null) {
    selectedYear = parseInt(selectedYear);
    let isAllYears = selectedYear === 0;
    let labelText = isAllYears ? 'All Years' : 'Year ' + selectedYear;
    let data = {
        years: selectedYear,
    };
    $.ajax({
        type: 'GET',
        url: base_url + 'pages/ajax_getYearSections',
        data: data,
        dataType: 'json',
        beforeSend: function () {
            $('#internal-link-results').hide();
            $('#internal-link-loader').show().html('<i class="' + FontAwesome.prefix('solid', 'spinner', true) + '"></i> Loading ' + labelText + ' Sections...');
        },
        success: function (data) {
            let buildSelect = '';
            const indent = '&nbsp;&nbsp;&nbsp;&nbsp;';
            if (data.length > 0) {
                let selectionMade = false;
                buildSelect += '<label for="" class="control-label">' + labelText + ' Sections</label>';
                buildSelect += '<select class="select2 form-control" id="internal-link" name="internal-link">';
                $.each(data, function (_, page) {
                    let $pageId = isAllYears ? page.page_id : page.subpage_id;
                    let $pageName = isAllYears ? page.page_name : page.subpage_name;
                    let pageSelected = '';
                    if ($pageId === pageNumber && selectionMade === false) {
                        pageSelected = 'selected';
                        selectionMade = true;
                    }
                    buildSelect += '<option class="bold-option" value="' + 'page:' + $pageId + '" title="' + $pageName  + '" ' + pageSelected + '>' + $pageName + '</option>';
                    $.each(page.sections, function (i, section) {
                        let sectionSelected = '';
                        if (section.id === sectionNumber && selectionMade === false) {
                            sectionSelected = 'selected';
                            selectionMade = true;
                        }
                        buildSelect += '<option value="' + 'page:' + $pageId + 'section:' + section.id + '" title="' + section.name  + '" ' + sectionSelected + '>' + indent + section.name + '</option>';
                        $.each(section.subSectionList, function (_, subSection) {
                            let subsectionSelected = '';
                            if (subSection.id === sectionNumber && selectionMade === false) {
                                subsectionSelected = 'selected';
                                selectionMade = true;
                            }
                            buildSelect += '<option value="' + 'page:' + $pageId + 'section:' + subSection.id + '" title="' + subSection.name + '" ' + subsectionSelected + '>' + indent + '-- ' + subSection.name + '</option>';
                        });
                    });
                });
                buildSelect += '</select>';

                $('#internal-link-results').empty().html(buildSelect).show();
            } else {
                $('#internal-link-results').html($('<div>', {
                    text: 'No sections for the year selected.',
                })).show();
            }
        },
        complete: function () {
            $('#internal-link-loader').hide();
        },
    });
}
